import React from 'react';

import { Text, UnstyledButton } from '@mantine/core';

interface AssignWorkoutSlotProps {
  onClick: () => void;
  variant?: 'box' | 'inline';
}

/** Clickable, but opens nothing until ENG-2387. */
const AssignWorkoutSlot = ({ onClick, variant = 'box' }: AssignWorkoutSlotProps): JSX.Element => (
  <UnstyledButton
    onClick={onClick}
    data-cy='assignWorkoutSlot'
    sx={theme => ({
      width: '100%',
      padding: variant === 'box' ? theme.spacing.md : 6,
      border: variant === 'box' ? `1px dashed ${theme.colors.gray[4]}` : 'none',
      borderRadius: theme.radius.sm,
      '&:hover': { backgroundColor: theme.colors.gray[0] },
    })}
  >
    <Text size={variant === 'box' ? 'sm' : 'xs'} align='center' color='gray.6'>
      Assign Workout
    </Text>
  </UnstyledButton>
);

export default AssignWorkoutSlot;
